export default __webpack_public_path__ + "3b05edea8b41975cc5927dab085e94b2.png";